// todo: add "addAsyncJob"
// todo: add "removeAsyncJob"
// state should have a concept of async jobs with id, status, type

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AsyncJob {
  id: string
  toastId?: string
  status: 'pending' | 'completed' | 'failed'
  type: 'workCard'
}

interface AsyncJobState {
  asyncJobs: AsyncJob[]
}

const initialState: AsyncJobState = {
  asyncJobs: [],
}

const asyncJobSlice = createSlice({
  name: 'asyncJob',
  initialState,
  reducers: {
    addAsyncJob: (state, action: PayloadAction<AsyncJob>) => {
      if (state.asyncJobs.some((job) => job.id === action.payload.id)) {
        return
      }
      state.asyncJobs.push(action.payload)
    },
    updateAsyncJob: (
      state,
      action: PayloadAction<{
        id: AsyncJob['id']
        status: AsyncJob['status']
        type: AsyncJob['type']
        toastId?: AsyncJob['toastId']
      }>
    ) => {
      const index = state.asyncJobs.findIndex(
        (job) => job.id === action.payload.id
      )
      if (index !== -1) {
        state.asyncJobs[index] = action.payload
      }
    },
    removeAsyncJob: (state, action: PayloadAction<AsyncJob['id']>) => {
      state.asyncJobs = state.asyncJobs.filter(
        (job) => job.id !== action.payload
      )
    },
  },
})

export const { addAsyncJob, updateAsyncJob, removeAsyncJob } =
  asyncJobSlice.actions

export default asyncJobSlice.reducer
